module.exports = __webpack_public_path__ + "static/media/360-tour-dark.620a5c23.svg";